import { useTranslation } from 'react-i18next';

const ErrorPage = () => {
  const { t } = useTranslation();
  return <div>{t('common.errorOccurred')}</div>;
};

export default ErrorPage;
